import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "../Buttons/Button";
import Loader from "../Loaders/Loader";
import {
  LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING,
  LEAD_FORM_RECOMMENDATION_CANCEL,
  LEAD_FORM_RECOMMENDATION_FAILED,
  LEAD_FORM_RECOMMENDATION_GENERATING,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";

const NOTICE_KEYS = {
  failed: LEAD_FORM_RECOMMENDATION_FAILED,
  campaignGenerating: LEAD_FORM_RECOMMENDATION_CAMPAIGN_GENERATING,
};

const NOTICE_SEVERITY = {
  failed: "warning",
  campaignGenerating: "warning",
};

const RecommendedLeadFormNotice = ({
  isGenerating = false,
  notice = null,
  onUseDefaults = () => {},
}) => {
  const { t } = useTranslationApp();
  const noticeKey = NOTICE_KEYS[notice];
  if (!isGenerating && !noticeKey) return null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {isGenerating ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            py: 4,
            gap: 2,
          }}
        >
          <Loader
            hasMessage
            message={t(LEAD_FORM_RECOMMENDATION_GENERATING)}
            size={28}
            hasMarginTop={false}
            alignMessage="center"
            fullWidth
          />
          <Button type="button" color="secondary" onClick={onUseDefaults}>
            {t(LEAD_FORM_RECOMMENDATION_CANCEL)}
          </Button>
        </Box>
      ) : null}
      {!isGenerating && noticeKey ? (
        <Alert severity={NOTICE_SEVERITY[notice] || "warning"}>
          {t(noticeKey)}
        </Alert>
      ) : null}
    </Box>
  );
};

export default RecommendedLeadFormNotice;
